export const PUT_UNUM_EXIT_APP_KEY = 'PUT_UNUM_EXIT_APP_KEY';
export const PUT_UNUM_SUBMIT_APPLICATION = 'PUT_UNUM_SUBMIT_APPLICATION';
